<template>
    <InformeCard
        title="Calendario cobros"
        collapsable="true"
    >
        <div v-if="plazos_calendario_cobros" class="row table-responsive">
            <b-col cols="12">
                <b-table hover :items="plazos_calendario_cobros" :fields="fields" id="plazos-table" :per-page="perPage" :current-page="currentPage">
                    <template #cell(fecha)="data">
                        {{ data.item.fecha_cobro_plazo }}
                    </template>
                    <template #cell(numero_cobros)="data">
                        {{ data.item.total }}
                    </template>
                    <template #cell(total)="data">
                        {{ data.item.importe_total | formatear_precio }}
                    </template>
                </b-table>
            </b-col>
            <b-pagination class="ml-3" :per-page="perPage" aria-controls="plazos-table" v-model="currentPage" :total-rows="plazos_calendario_cobros.length" size="sm"/>
        </div>
        <div v-else>
            No se ha realizado ningún pago a plazos
        </div>
    </InformeCard>
</template>

<script>
    import InformeCard from "../InformeCard";

    export default {
        props: ['lista_id'],
        data() {
            return {
                fields: [
                    { key: 'fecha', label: 'Fecha', class: 'text-center' },
                    { key: 'numero_cobros', label: 'Nº de cobros', class: 'text-center' },
                    { key: 'total', label: 'Total', class: 'text-center' },
                ],
                perPage: 10,
                currentPage: 1,
                plazos_calendario_cobros: null
            }
        },
        methods: {
            getPlazosCalendarioCobro() {
                this.loading = true;

                const params = {
                    lista_id: this.lista_id,
                    filters: {}
                };

                this.$store.dispatch(this.config.getVuexAlias('back.bases.informe.plazos-calendarios-cobro'), params).then(res => {
                    this.plazos_calendario_cobros = res.data.plazos_calendario_cobros;
                }).finally(() => this.loading = false);
            }
        },
        created() {
            this.getPlazosCalendarioCobro();
        },
        components: {
            InformeCard,
        }
    }
</script>